var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8292 21.5099C20.8924 21.536 20.9601 21.5495 21.0286 21.5494C21.1316 21.5494 21.2323 21.5189 21.318 21.4616C21.4036 21.4044 21.4704 21.3231 21.5098 21.2279C21.5493 21.1327 21.5596 21.028 21.5395 20.9269C21.5194 20.8259 21.4697 20.7331 21.3969 20.6602L16.9528 16.2161L21.3969 11.772C21.4946 11.6743 21.5495 11.5419 21.5495 11.4037C21.5495 11.2656 21.4946 11.1331 21.3969 11.0354C21.2992 10.9377 21.1667 10.8828 21.0286 10.8828C20.8904 10.8828 20.7579 10.9377 20.6603 11.0354L16.2161 15.4795L11.772 11.0354C11.6743 10.9377 11.5419 10.8828 11.4037 10.8828C11.2656 10.8828 11.1331 10.9377 11.0354 11.0354C10.9377 11.1331 10.8828 11.2656 10.8828 11.4037C10.8828 11.5419 10.9377 11.6743 11.0354 11.772L15.4795 16.2161L11.0354 20.6602C10.9625 20.7331 10.9129 20.8259 10.8928 20.9269C10.8727 21.028 10.883 21.1327 10.9225 21.2279C10.9619 21.3231 11.0287 21.4044 11.1143 21.4616C11.2 21.5189 11.3007 21.5494 11.4037 21.5494C11.4721 21.5495 11.5399 21.536 11.6031 21.5099C11.6663 21.4837 11.7237 21.4453 11.7721 21.3969L16.2161 16.9528L20.6602 21.3969C20.7086 21.4453 20.766 21.4837 20.8292 21.5099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modalCloseIcon.a4ed74f2dc96d5d49e779dc6a033e7e6.svg";
export { ForwardRef as ReactComponent };